// Third Party
import $ from 'jquery';

export default {
	install(Vue, options) {
		// v-focus
		Vue.directive('focus', {
			inserted: function (el) {
				el.focus()
			}
		});

		Vue.directive("tooltip", {
            bind(el, binding) {
                const isTouchDevice =
                    "ontouchstart" in window ||
                    (window.DocumentTouch && document instanceof DocumentTouch);

                // Initialize the tooltip
                $(el).tooltip({
                    title: binding.value,
                    placement: binding.arg,
                    trigger: isTouchDevice ? "click" : "hover",
                });
            },
            update(el, binding) {
                // Update the tooltip content and reinitialize it with new content
                $(el)
                    .attr("title", binding.value)
                    .tooltip("dispose")
                    .tooltip({
                        title: binding.value,
                        placement: binding.arg,
                        trigger: "ontouchstart" in window ? "click" : "hover",
                    });
            },
            unbind(el) {
                // Cleanup when directive is unbound
                $(el).tooltip("dispose");
            },
        });
	}
}